import { useAuth } from 'react-oidc-context';
import { getProjectRoles } from 'lib/auth/authUtils';

// Zitadel project-role key that grants access to the IMINT module.
export const IMINT_ROLE = 'imint';

// True when the current user's token carries the `imint` project role.
// Reads roles from the token claim (not the single `role` string on /api/me),
// so it's correct for users holding multiple roles.
export const hasImintRole = (token) => getProjectRoles(token).includes(IMINT_ROLE);

// Reactive variant for components: re-evaluates as OIDC auth state settles.
// A user with this role gets the EXCLUSIVE IMINT shell (only IMINT is rendered).
// The token is read straight off the reactive `auth.user` — on reload the
// in-memory tokenStore is filled by TokenSync's EFFECT (one render after auth
// restores), and the store isn't reactive, so reading it here left the shell
// stuck on the customer navbar until an unrelated re-render.
export const useIsImintUser = () => {
  const auth = useAuth();
  return !!auth.isAuthenticated && hasImintRole(auth.user && auth.user.access_token);
};
